






















































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePemantauanPacu } from "@/store/modules/PemantauanPacuStore";
import { appModule } from "@/store/modules/app";
import PemantauanPacuSvc from "@/services/PemantauanPacuService";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import MonitoringPacuInputModal from "@/components/pemantauan-pacu/MonitoringPacuInputModal.vue";
import moment from "moment";

interface EfekEntry {
  status: string | null; // 'ya' | 'tidak' | null
  pengobatan: string;
  lain_lain: string;
}

@Component({
  components: { CardModalTtd, MonitoringPacuInputModal },
  filters: {
    formatDateTime(v: string) {
      return v ? moment(v).format("DD-MM-YYYY HH:mm") : "";
    },
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PemantauanPacuPage extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  loaded = false;
  saving = false;
  creating = false;
  deleting = false;

  createDialog = false;
  deleteDialog = false;
  monitoringModal = false;
  ttdModal = false;

  editingMonitoring: any = null;
  ttdRole: "perawat" | "dokter" | null = null;

  form: any = this.blankForm();
  efekSamping: Record<string, EfekEntry> = this.blankEfek();

  efekTypes = [
    { key: "mual_muntah", label: "Mual / Muntah" },
    { key: "menggigil", label: "Menggigil" },
    { key: "hipotensi", label: "Hipotensi" },
    { key: "hipertensi", label: "Hipertensi" },
    { key: "kesakitan", label: "Kesakitan" },
    { key: "lain_lain", label: "Lain-lain" },
  ];

  instruksiItems = [
    { key: "instruksi_observasi", label: "Observasi" },
    { key: "instruksi_posisi", label: "Posisi" },
    { key: "instruksi_infus", label: "Infus" },
    { key: "instruksi_analgetik", label: "Analgetik" },
    { key: "instruksi_anti_muntah", label: "Anti muntah" },
    { key: "instruksi_mobilisasi", label: "Mobilisasi" },
    { key: "instruksi_perhatian_khusus", label: "Perhatian Khusus" },
  ];

  get pacu() { return storePemantauanPacu.currentItem; }
  get loading() { return storePemantauanPacu.loading; }
  get locked() { return this.pacu?.is_locked; }

  get monitoringRows() {
    return (this.pacu && this.pacu.monitoring) || [];
  }

  get canCreate() {
    return !!(this.form.pukul_datang && this.form.kesadaran_datang && this.form.jalan_nafas && this.form.pernafasan);
  }

  get kondisiLabel(): string {
    const k = this.pacu?.kesadaran_datang;
    if (k === "sadar_betul") return "Sadar Betul";
    if (k === "belum_sadar") return "Belum Sadar";
    if (k === "tidur_dalam") return "Tidur Dalam";
    return "-";
  }

  get kondisiColor(): string {
    const k = this.pacu?.kesadaran_datang;
    if (k === "sadar_betul") return "green";
    if (k === "belum_sadar") return "orange";
    if (k === "tidur_dalam") return "red";
    return "grey";
  }

  get tujuanLabel(): string {
    const t = this.pacu?.tujuan_keluar;
    if (t === "icu") return "ICU";
    if (t === "ruang_rawat") return "Ruang Rawat";
    if (t === "pulang") return "Pulang";
    return "-";
  }

  get statusLabel(): string {
    if (this.pacu?.is_locked) return "Selesai";
    if (this.pacu?.pukul_keluar) return "Keluar PACU";
    if (this.monitoringRows.length > 0) return "Observasi Berjalan";
    return "Baru Masuk";
  }

  get statusColor(): string {
    if (this.pacu?.is_locked) return "green";
    if (this.pacu?.pukul_keluar) return "teal";
    if (this.monitoringRows.length > 0) return "blue";
    return "grey";
  }

  get criteriaAlert() {
    const total = this.pacu?.latest_aldrete_total;
    if (total === null || total === undefined) return null;
    if (total >= 9) return { type: "success", text: `Aldrete terakhir ${total}/10 — pasien BOLEH dipindahkan` };
    if (total >= 5) return { type: "warning", text: `Aldrete terakhir ${total}/10 — belum memenuhi kriteria pindah (perlu ≥ 9)` };
    return { type: "error", text: `Aldrete terakhir ${total}/10 — pasien memerlukan observasi intensif` };
  }

  blankEfek(): Record<string, EfekEntry> {
    const out: Record<string, EfekEntry> = {};
    ["mual_muntah", "menggigil", "hipotensi", "hipertensi", "kesakitan", "lain_lain"].forEach(k => {
      out[k] = { status: null, pengobatan: "", lain_lain: "" };
    });
    return out;
  }

  blankForm() {
    return {
      pukul_datang: "",
      kesadaran_datang: null,
      jalan_nafas: null,
      pernafasan: null,
      instruksi_observasi: false,
      instruksi_observasi_detail: "",
      instruksi_posisi: false,
      instruksi_posisi_detail: "",
      instruksi_infus: false,
      instruksi_infus_detail: "",
      instruksi_analgetik: false,
      instruksi_analgetik_detail: "",
      instruksi_anti_muntah: false,
      instruksi_anti_muntah_detail: "",
      instruksi_mobilisasi: false,
      instruksi_mobilisasi_detail: "",
      instruksi_perhatian_khusus: false,
      instruksi_perhatian_khusus_detail: "",
      pukul_keluar: "",
      tujuan_keluar: null,
      laporan_operasi_id: null,
    };
  }

  @Watch("isActive", { immediate: true })
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.fetchData();
      this.loaded = true;
    }
  }

  @Watch("pacu")
  onPacuChange(p: any) {
    if (p) this.syncFormFromPacu(p);
  }

  async fetchData() {
    await storePemantauanPacu.getByRegister(this.register);
    if (this.pacu) this.syncFormFromPacu(this.pacu);
  }

  syncFormFromPacu(p: any) {
    this.form = {
      pukul_datang: (p.pukul_datang || "").substring(0, 5),
      kesadaran_datang: p.kesadaran_datang,
      jalan_nafas: p.jalan_nafas,
      pernafasan: p.pernafasan,
      instruksi_observasi: !!p.instruksi_observasi,
      instruksi_observasi_detail: p.instruksi_observasi_detail || "",
      instruksi_posisi: !!p.instruksi_posisi,
      instruksi_posisi_detail: p.instruksi_posisi_detail || "",
      instruksi_infus: !!p.instruksi_infus,
      instruksi_infus_detail: p.instruksi_infus_detail || "",
      instruksi_analgetik: !!p.instruksi_analgetik,
      instruksi_analgetik_detail: p.instruksi_analgetik_detail || "",
      instruksi_anti_muntah: !!p.instruksi_anti_muntah,
      instruksi_anti_muntah_detail: p.instruksi_anti_muntah_detail || "",
      instruksi_mobilisasi: !!p.instruksi_mobilisasi,
      instruksi_mobilisasi_detail: p.instruksi_mobilisasi_detail || "",
      instruksi_perhatian_khusus: !!p.instruksi_perhatian_khusus,
      instruksi_perhatian_khusus_detail: p.instruksi_perhatian_khusus_detail || "",
      pukul_keluar: (p.pukul_keluar || "").substring(0, 5),
      tujuan_keluar: p.tujuan_keluar,
      laporan_operasi_id: p.laporan_operasi_id,
    };

    const incoming = p.efek_samping || {};
    const fresh = this.blankEfek();
    Object.keys(fresh).forEach(k => {
      if (incoming[k]) {
        fresh[k] = {
          status: incoming[k].status || null,
          pengobatan: incoming[k].pengobatan || "",
          lain_lain: incoming[k].lain_lain || "",
        };
      }
    });
    this.efekSamping = fresh;
  }

  setEfekStatus(key: string, val: string) {
    this.efekSamping[key].status = val;
    this.efekSamping = { ...this.efekSamping };
  }

  aldreteColor(total: number | null): string {
    if (total === null || total === undefined) return "grey";
    if (total >= 9) return "green";
    if (total >= 5) return "orange";
    return "red";
  }

  formatPukul(p: string): string {
    return (p || "").substring(0, 5);
  }

  startCreate() {
    this.form = this.blankForm();
    const now = new Date();
    this.form.pukul_datang = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
    this.createDialog = true;
  }

  async createForm() {
    this.creating = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        pukul_datang: this.form.pukul_datang,
        kesadaran_datang: this.form.kesadaran_datang,
        jalan_nafas: this.form.jalan_nafas,
        pernafasan: this.form.pernafasan,
        laporan_operasi_id: this.form.laporan_operasi_id || null,
      };
      const resp = await PemantauanPacuSvc.create(payload);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Form Pemantauan PACU/RR dibuat");
        this.createDialog = false;
        await this.fetchData();
      }
    } catch (e) { /* handled */ }
    this.creating = false;
  }

  async saveParent() {
    if (!this.pacu?.id) return;
    this.saving = true;
    try {
      const payload = {
        ...this.form,
        efek_samping: this.efekSamping,
      };
      const resp = await PemantauanPacuSvc.update(this.pacu.id, payload);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Perubahan disimpan");
        await this.fetchData();
      }
    } catch (e) { /* handled */ }
    this.saving = false;
  }

  openAddMonitoring() {
    this.editingMonitoring = null;
    this.monitoringModal = true;
  }

  editMonitoring(item: any) {
    this.editingMonitoring = item;
    this.monitoringModal = true;
  }

  async deleteMonitoring(item: any) {
    if (!confirm("Hapus observasi ini?")) return;
    try {
      const resp = await PemantauanPacuSvc.deleteMonitoring(item.id);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Observasi dihapus");
        await this.fetchData();
      }
    } catch (e) { /* handled */ }
  }

  async onMonitoringSaved() {
    await this.fetchData();
  }

  openTtd(role: "perawat" | "dokter") {
    this.ttdRole = role;
    this.ttdModal = true;
  }

  async doSign(password: string) {
    if (!this.pacu?.id || !this.ttdRole) return;
    try {
      const fn = this.ttdRole === "perawat"
        ? PemantauanPacuSvc.signPerawat
        : PemantauanPacuSvc.signDokter;
      const resp = await fn(this.pacu.id, { password });
      if (resp?.data?.status === "1") {
        this.ttdModal = false;
        appModule.NoticeDelay("Berhasil tanda tangan");
        appModule.addMsgTtd("");
        await this.fetchData();
      } else {
        appModule.addMsgTtd(resp?.data?.message || "Gagal TTD");
        this.ttdModal = true;
      }
    } catch (e) {
      this.ttdModal = true;
    }
  }

  confirmDelete() { this.deleteDialog = true; }

  async doDelete() {
    if (!this.pacu?.id) return;
    this.deleting = true;
    try {
      const resp = await PemantauanPacuSvc.destroy(this.pacu.id);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Form dihapus");
        storePemantauanPacu.reset();
        this.deleteDialog = false;
      }
    } catch (e) { /* handled */ }
    this.deleting = false;
  }

  printPdf() {
    if (this.pacu?.id) PemantauanPacuSvc.printPdf(this.pacu.id);
  }

  beforeDestroy() {
    storePemantauanPacu.reset();
  }
}
